module.exports = __webpack_public_path__ + "static/media/menuHouse.2c345c9e.svg";